import { graphql } from '@/gql';
import type { CancelScheduledGroceryMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelScheduledGrocery = async ({ id, reason }: CancelScheduledGroceryMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CancelScheduledGrocery($id: Float!, $reason: String!) {
        cancelScheduledGrocery(id: $id, reason: $reason)
      }
    `),
    variables: {
      id,
      reason,
    },
  });

  return response.data?.cancelScheduledGrocery ?? false;
};
